import './bootstrap';

import { createApp } from 'vue';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import axios from 'axios';
window.axios = axios;
import flatpickr from 'flatpickr';
import { initSideOverlayBodyLock } from './helpers/sideOverlayBodyLock';

window.Swal = Swal;

import { configureEcho } from "@laravel/echo-vue";

initSideOverlayBodyLock();

if (typeof VITE_PUSHER_KEY !== 'undefined' && VITE_PUSHER_KEY !== '') {
    configureEcho({
        broadcaster: "pusher",
        key: VITE_PUSHER_KEY,
        cluster: VITE_PUSHER_CLUSTER,
        wsHost: (VITE_PUSHER_HOST == 'soketi') ? 'movements.jk.localhost' : VITE_PUSHER_HOST,
        wsPort: VITE_PUSHER_PORT,
        forceTLS: VITE_PUSHER_USETLS,
        encrypted: true,
        enableStats: false,
        enabledTransports: ["wss", "ws"],
    });
}

import DynamicSelect from "./components/dynamic-select.vue";
import ExpandingTextarea from "./components/expanding-textarea.vue";
import UniversalSelect2 from "./components/universal-select-2.vue";

import AdminUsersList from "./components/admin/users/list.vue";
import ClassicsStaffList from "./components/classics/staff/list.vue";
import ClassicsFilesUpload from "./components/classics/files/upload.vue";
import ClassicsJobsForm from "./components/classics/jobs/form.vue";
import ClassicsJobsMerge from "./components/classics/jobs/merge.vue";
import ClassicsJobs from "./components/classics/jobs/index.vue";
import ClassicsTimeEntriesDuplicate from "./components/classics/timeEntries/duplicate.vue";
import ClassicsTimeEntriesMove from "./components/classics/timeEntries/move.vue";
import ClassicsTimeEntriesForm from "./components/classics/timeEntries/form.vue";
import ClassicsTimeEntriesList from "./components/classics/timeEntries/list.vue";
import ClassicsCustomersList from "./components/classics/customers/list.vue";
import ClassicsCustomersPicker from "./components/classics/customers/picker.vue";
import ClassicsVehiclesList from "./components/classics/vehicles/list.vue";
import ClassicsVehiclesJobs from "./components/classics/vehicles/jobs.vue";
import ClassicsVehiclesFiles from "./components/classics/vehicles/files.vue";
import ClassicsVehiclesWipReportPicker from "./components/classics/vehicles/wipReportPicker.vue";
import ClassicsVehiclesWriteOffTimeEntries from "./components/classics/vehicles/writeOffTimeEntries.vue";
import ClassicsTimeTracker from "./components/classics/timetracker.vue";
import SettingsEdit from "./components/settings/edit.vue";
import SettingsSelect from "./components/settings/settingsSelect.vue";
import SettingsTaxRates from "./components/settings/taxRates.vue";
import SettingsAccountCodes from "./components/settings/accountCodes.vue";
import ClassicsPurchaseInvoicesTable from "./components/classics/purchaseInvoices/index.vue";
import ClassicsPurchaseInvoicesApprove from "./components/classics/purchaseInvoices/approve.vue";
import ClassicsSalesInvoicesTable from "./components/classics/salesInvoices/index.vue";
import ClassicsSalesInvoicesForm from "./components/classics/salesInvoices/form.vue";
import ClassicsSalesInvoicesEdit from "./components/classics/salesInvoices/edit.vue";
import PortalQuoteList from "./components/portal/dashboard/quoteList.vue";
import PortalJobList from "./components/portal/dashboard/jobList.vue";
import PortalNewJob from "./components/portal/newJob.vue";
import PortalVehiclesSelectModal from "./components/portal/vehicles/selectModal.vue";
import AddContactModal from "./components/portal/addContactModal.vue";

import MovementsCustomersCreate from "./components/movements/customers/Create.vue";
import MovementsCustomersEdit from "./components/movements/customers/Edit.vue";
import MovementsCustomersInvoiceAutomation from "./components/movements/customers/InvoiceAutomation.vue";
import MovementsCustomersList from "./components/movements/customers/List.vue";
import MovementsMovementsShow from "./components/movements/movements/Show.vue";
import MovementsMovementsEdit from "./components/movements/movements/Edit.vue";

import MovementsContractsList from "./components/movements/contracts/List.vue";
import MovementsInvoicesList from "./components/movements/invoices/List.vue";
import MovementsJobsList from "./components/movements/jobs/List.vue";
import MovementsQuotesList from "./components/movements/quotes/List.vue";
import MovementsMovementsList from "./components/movements/movements/List.vue";
import MovementsMessagesList from "./components/movements/messages/List.vue";
import MovementsAddressesList from "./components/movements/addresses/List.vue";
import MovementsContactsList from "./components/movements/contacts/List.vue";
import MovementsVehiclesList from "./components/movements/vehicles/List.vue";
import MovementsUsersList from "./components/movements/users/List.vue";
import MovementFuelCardsList from "./components/movements/fuelcards/List.vue";

import MovementsDriversList from "./components/movements/drivers/List.vue";
import MovementsAgenciesList from "./components/movements/agencies/List.vue";
import MovementsCreditNoteList from "./components/movements/creditnotes/List.vue";
import MovementsInvoicesPickJobsList from "./components/movements/invoices/pickjobs/List.vue";
import MovementsPoList from "./components/movements/po/List.vue";
import MovementsPoBulkActions from "./components/movements/po/BulkActions.vue";
import MovementsInvoicingList from "./components/movements/invoicing/List.vue";
import MovementsInvoicingBulkActions from "./components/movements/invoicing/BulkActions.vue";

import MovementsComponentsCustomersSelect from "./components/movements/components/CustomerSelect.vue";
import MovementsComponentsRateSelect from "./components/movements/components/vehicle/RateSelect.vue";
import MovementsComponentsTypeSelect from "./components/movements/components/vehicle/TypeSelect.vue";
import MovementsComponentsDriverSelect from "./components/movements/components/DriverSelect.vue";
import MovementsComponentsUserSelect from "./components/movements/components/UserSelect.vue";
import MovementsComponentsAgencySelect from "./components/movements/components/AgencySelect.vue";
import MovementsComponentsPayRateSelect from "./components/movements/components/PayRateSelect.vue";
import MovementsComponentsDuplicateJob from "./components/movements/components/DuplicateJob.vue";
import MovementsComponentsSplit from "./components/movements/movements/Split.vue";
import MovementsComponentsFileUpload from "./components/movements/components/FileUpload.vue";

import MovementsComponentsGroupSelect from "./components/movements/components/GroupSelect.vue";
import MovementsSidebar from "./components/movements/Sidebar.vue";

import MovementJobsBulkUpdate from "./components/movements/jobs/BulkUpdate.vue";
import MovementJobsBulkGenerateInvoices from "./components/movements/jobs/BulkGenerateInvoices.vue";
import MovementJobsBulkSelection from "./components/movements/jobs/BulkSelection.vue";
import MovementJobsCreate from "./components/movements/jobs/Create.vue";
import MovementJobsEdit from "./components/movements/jobs/Edit.vue";
import MovementJobsMoveIndex from "./components/movements/jobs/move/Index.vue";
import MovementJobsChangeDestination from "./components/movements/jobs/change-destination/Index.vue";

import MovementJobsSignoff from "./components/movements/jobs/signoff/Signoff.vue";

import MovementJobsExpenses from "./components/movements/jobs/signoff/Expenses.vue";

import MovementMovementsAssignDriver from "./components/movements/movements/AssignDriver.vue";

import MovementJobsPlanner from "./components/movements/jobs/planner/Planner.vue";
import MovementJobsPlannerMap from "./components/movements/jobs/planner/PlannerMap.vue";

import MovementJobsTrackingMap from "./components/movements/jobs/tracking/Map.vue";

import MovementJobsSignoffConfirmation from "./components/movements/jobs/signoff/Confirmation.vue";
import MovementJobsReview from "./components/movements/jobs/review/Review.vue";

import MovementReportsGroupedJob from "./components/movements/reports/GroupedJobsForm.vue";
import MovementReportsDriverMovements from "./components/movements/reports/drivers/movements/DriversMovementsReport.vue";
import MovementReportsCompletedMovements from "./components/movements/reports/drivers/movements/CompletedMovementsReport.vue";

import SwalComponent from './components/movements/components/Swal.vue';
import EstimateRoute from './components/movements/components/EstimateRoute.vue';
import EstimateChangeDestinationRoute from './components/movements/components/EstimateChangeDestinationRoute.vue';
import PlotRoute from './components/movements/components/PlotRoute.vue';
import PlannerModalTransported from './components/movements/jobs/planner/Transported.vue';

// Comments are typically one of many, don't remove without checking for other files first
const components = {
    'dynamic-select': DynamicSelect, // new-invoice.blade.php
    'expanding-textarea': ExpandingTextarea, // salesInvoice/edit.blade.php
    'universal-select-2': UniversalSelect2, // jobDetails.blade.php
    'admin-users-list': AdminUsersList, // admin/users/index.blade.php
    'classics-staff-list': ClassicsStaffList, // classics/staff/index.blade.php
    'classics-files-upload': ClassicsFilesUpload, // classics/vehicles/show.blade.php
    'classics-jobs-form': ClassicsJobsForm, // classics/jobs/show.blade.php
    'classics-jobs-merge': ClassicsJobsMerge, // classics/vehicles/show.blade.php
    'classics-jobs': ClassicsJobs, // classics/jobs/index.blade.php
    'classics-time-entries-duplicate': ClassicsTimeEntriesDuplicate, // timeEntries.blade.php
    'classics-time-entries-move': ClassicsTimeEntriesMove, // timeEntries.blade.php
    'classics-time-entries-form': ClassicsTimeEntriesForm, // timeEntries.blade.php
    'classics-time-entries-list': ClassicsTimeEntriesList, // timeEntries.blade.php
    'classics-customers-list': ClassicsCustomersList, // customers/index.blade.php
    'classics-customers-picker': ClassicsCustomersPicker, // vehicles/form.blade.php
    'classics-vehicles-list': ClassicsVehiclesList, // classics/dashboard.blade.php
    'classics-vehicles-jobs': ClassicsVehiclesJobs, // vehicles/show/jobs.blade.php
    'classics-vehicles-files': ClassicsVehiclesFiles, // files.blade.php
    'classics-vehicles-wip-report-picker': ClassicsVehiclesWipReportPicker, // classics/vehicles/index.blade.php
    'classics-vehicles-write-off-time-entries': ClassicsVehiclesWriteOffTimeEntries, // timeEntries.blade.php
    'classics-timetracker': ClassicsTimeTracker, // classics/settings/timetracker.blade.php
    'settings-edit': SettingsEdit, // classics/settings/index.blade.php
    'settings-select': SettingsSelect, // classics/settings/index.blade.php
    'settings-tax-rates': SettingsTaxRates, // classics/settings/index.blade.php
    'settings-account-codes': SettingsAccountCodes, // list.blade.php
    'classics-purchase-invoices-table': ClassicsPurchaseInvoicesTable, //vehicles/purchaseInvoices.blade.php
    'classics-purchase-invoices-approve': ClassicsPurchaseInvoicesApprove, // classics/purchaseInvoices/index.blade.php
    'classics-sales-invoices-table': ClassicsSalesInvoicesTable, // customers/salesInvoices.blade.php
    'classics-sales-invoices-form': ClassicsSalesInvoicesForm, // sales-invoices/form.blade.php
    'classics-sales-invoices-edit': ClassicsSalesInvoicesEdit, // classics/salesInvoices/show.blade.php
    'portal-quote-list': PortalQuoteList, // portal/dashboard.blade.php
    'portal-job-list': PortalJobList, // portal/dashboard.blade.php
    'portal-new-job': PortalNewJob, // editJob.blade.php
    'portal-vehicles-select-modal': PortalVehiclesSelectModal, // portal/quotes/view.blade.php
    'add-contact-modal': AddContactModal, // jobDetails.blade.php
    'movements-customers-create': MovementsCustomersCreate, // customers/create.blade.php
    'movements-customers-edit': MovementsCustomersEdit, // customers/edit.blade.php
    'movements-customers-invoice-automation': MovementsCustomersInvoiceAutomation, // customers/create.blade.php + customers/edit.blade.php
    'movements-customers-list': MovementsCustomersList, // customers/index.blade.php
    'movements-movements-show': MovementsMovementsShow, // movements/show.blade.php
    'movements-movements-edit': MovementsMovementsEdit, // movements/edit.blade.php
    'movements-contracts-list': MovementsContractsList, // contracts/index.blade.php
    'movements-invoices-list': MovementsInvoicesList, // invoices/index.blade.php
    'movements-jobs-list': MovementsJobsList, // jobs/index.blade.php
    'movements-fuel-cards-list': MovementFuelCardsList, // fuel-cards/index.blade.php
    'movements-quotes-list': MovementsQuotesList, // quotes/index.blade.php
    'movements-movements-list': MovementsMovementsList, // drivers/show.blade.php
    'movements-messages-list': MovementsMessagesList, // drivers/show.blade.php
    'movements-addresses-list': MovementsAddressesList, // addresses/index.blade.php
    'movements-contacts-list': MovementsContactsList, // contacts/index.blade.php
    'movements-vehicles-list': MovementsVehiclesList, // vehicles/index.blade.php
    'movements-users-list': MovementsUsersList, // users/index.blade.php
    'movements-drivers-list': MovementsDriversList, // drivers/index.blade.php
    'movements-agencies-list': MovementsAgenciesList, // agencies/index.blade.php
    'movements-credit-note-list': MovementsCreditNoteList, // creditnotes/index.blade.php
    'movements-invoices-pick-jobs-list': MovementsInvoicesPickJobsList, // pick-jobs.blade.php
    'movements-po-list': MovementsPoList, // po/index.blade.php
    'movements-po-bulk-actions': MovementsPoBulkActions, // po/index.blade.php
    'movements-invoicing-list': MovementsInvoicingList, // invoicing/index.blade.php
    'movements-invoicing-bulk-actions': MovementsInvoicingBulkActions, // invoicing/index.blade.php
    'movements-components-customers-select': MovementsComponentsCustomersSelect, // lots of places >.>
    'movements-components-rate-select': MovementsComponentsRateSelect, // contracts/create.blade.php
    'movements-components-type-select': MovementsComponentsTypeSelect, // vehicles/create.blade.php
    'movements-components-driver-select': MovementsComponentsDriverSelect, // users/create.blade.php
    'movements-components-user-select': MovementsComponentsUserSelect, // drivers/edit.blade.php
    'movements-components-agency-select': MovementsComponentsAgencySelect, // drivers/edit.blade.php
    'movements-components-pay-rate-select': MovementsComponentsPayRateSelect, // drivers/create.blade.php
    'movements-components-duplicate-job': MovementsComponentsDuplicateJob, // duplicate.blade.php
    'movements-components-split-job': MovementsComponentsSplit, // split.blade.php
    'movements-components-file-upload': MovementsComponentsFileUpload, // drivers/edit.blade.php
    'movements-components-group-select': MovementsComponentsGroupSelect, // users/create.blade.php
    'movements-sidebar': MovementsSidebar, // backend.blade.php
    'movements-jobs-bulk-update': MovementJobsBulkUpdate, // jobs/index.blade.php
    'movements-jobs-bulk-generate-invoices': MovementJobsBulkGenerateInvoices, // jobs/index.blade.php
    'movements-jobs-bulk-selection': MovementJobsBulkSelection, // jobs/index.blade.php
    'movements-jobs-create': MovementJobsCreate, // jobs/create.blade.php
    'movements-jobs-edit': MovementJobsEdit, // jobs/edit.blade.php
    'movements-jobs-move-index': MovementJobsMoveIndex, // move/index.blade.php
    'movements-jobs-change-destination': MovementJobsChangeDestination, // change-destination.blade.php
    'movements-jobs-signoff': MovementJobsSignoff, // jobs/signoff/index.blade.php
    'movements-jobs-expenses': MovementJobsExpenses, // expenses.blade.php
    'movements-movements-assign-driver': MovementMovementsAssignDriver, // assign.blade.php
    'movements-jobs-planner': MovementJobsPlanner, // planner/index.blade.php
    'movements-jobs-planner-map': MovementJobsPlannerMap, // planner/map.blade.php
    'movements-jobs-tracking-map': MovementJobsTrackingMap, // tracking/map/index.blade.php
    'movements-jobs-signoff-confirmation': MovementJobsSignoffConfirmation, // confirmation.blade.php
    'movements-jobs-review': MovementJobsReview, // jobs/review/show.blade.php
    'movements-reports-grouped-job': MovementReportsGroupedJob, // groupedJobs/form.blade.php
    'movements-reports-driver-movements': MovementReportsDriverMovements, // drivers/movements/index.blade.php
    'movements-reports-completed-movements': MovementReportsCompletedMovements, // completed/movements/index.blade.php
    'swal': SwalComponent, // backend.blade.php
    'estimate-route': EstimateRoute, // Split.blade.php
    'estimate-change-destination-route': EstimateChangeDestinationRoute, // change-destination/index.blade.php
    'plot-route': PlotRoute, // movements/jobs/show.blade.php
    'planner-modal-transported': PlannerModalTransported, // modal-content.blade.php
};

import Helpers from './oneui/modules/helpers.js';

let n = 0;
for (const tag in components) {
    for (const el of document.querySelectorAll(tag)) {
        try {
            const app = createApp({
                template: el.outerHTML,
                name: `${tag} ${++n}`,
            });
            app.component(tag, components[tag]);
            app.mount(el);
            app.runWithContext(() => {
                Helpers.run("bs-popover");
            });
        } catch (e) {
            console.error(`Error mounting component ${tag}:`, e);
        }
    }
}

import './oneui/app.js';



let goToTabFromHash = function () {
    const hash = window.location.hash.split('#');
    const currentTab = document.querySelector('.nav-link[data-bs-target="#' + hash[1] + '"]');
    if (currentTab) {
        const bsTab = new bootstrap.Tab(currentTab);
        bsTab.show();
    }
};

// are we deep-linked to a tab?
if (window.location.hash) {
    goToTabFromHash();
}

let tabButtons = document.querySelectorAll('.nav-link[data-bs-target]');
if (tabButtons.length) {
    for (let tabButton of tabButtons) {
        tabButton.addEventListener('show.bs.tab', function (ev) {
            window.location.hash = ev.target.getAttribute('data-bs-target');
        });

        // don't think I like this
        // if (tabButton.classList.contains('active')) {
        //     window.location.hash = tabButton.getAttribute('data-bs-target');
        // }
    }

    window.onpopstate = goToTabFromHash;
}

import { Eventbus } from '@/components/eventbus';

flatpickr('.js-flatpickers');

import $ from 'jquery';
window.$ = $;

window.jQuery('#main-container').on('click', '.js-emit', function () {
    Eventbus.emit(window.jQuery(this).data('emit-action'), window.jQuery(this).data('emit-payload'));
});

window.jQuery('#main-container').on('click', '.js-confirmDelete', async function () {
    let result = await Swal.fire({
        title: 'Do you want to delete this?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
    });

    if (! result.isConfirmed) {
        return;
    }

    let button = window.jQuery(this);

    await axios.delete(button.data('delete-href'));

    Swal.fire({
        icon: 'success',
        title: 'Deleted',
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
    });

    if (button.data('delete-then')) {
        Eventbus.emit(button.data('delete-then'));
    }
});
